import React, { useEffect, useState } from "react";
import {
  buildSunburstData,
  buildTreemapData,
  sumArrayOfObjects,
} from "../../Utilitie";
import LineRaceChart from "../../CHARTS/LineRaceChart";
import TreeMapChart2 from "../../CHARTS/TreeMapChart2";
import { RiResetLeftFill } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SunburstChart from "../../CHARTS/SunburstChart";
const CrewOutsideGraph = ({
  data,
  setTreeMapPath,
  setSelectedLineBar,
  selectedBar,
}) => {
  const tempLobbyWise = sumArrayOfObjects(
    data,
    ["os_lobby", "os_year"],
    ["os_lobby"],
    "group",
  );
  const chartDataLobbyWise = tempLobbyWise.map((o) => {
    return { time: o.os_lobby, occurrence: o.os_total_occurence };
  });
  const [selectedLobby, setSelectedLobby] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const getLobbyObject = (selectedBar) => {
    return selectedBar?.find((item) => "lobby" in item)?.lobby || null;
  };
  const getMonthObject = (selectedBar) => {
    return selectedBar?.find((item) => "month" in item)?.month || null;
  };
  useEffect(() => {
    setSelectedLobby(getLobbyObject(selectedBar));
    setSelectedMonth(getMonthObject(selectedBar));
  }, [selectedBar]);

  const filteredData =
    selectedLobby === "" || !selectedLobby
      ? data
      : data.filter((o) => o.os_lobby === selectedLobby);

  const tempMonthWise = sumArrayOfObjects(
    filteredData,
    ["os_month", "os_year"],
    ["os_month"],
    "group",
  );
  const chartDataMonthWise = tempMonthWise.map((o) => {
    return { time: o.os_month, occurrence: o.os_total_occurence };
  });

  const filteredDataForTreeMap =
    selectedMonth === "" || !selectedMonth
      ? filteredData
      : filteredData.filter((o) => o.os_month === selectedMonth);

  const treeMapData =
    data &&
    buildTreemapData(
      filteredDataForTreeMap,
      ["os_lobby", "os_station", "os_month"],
      "os_total_occurence",
      "occurrence",
    );
  const a = buildSunburstData(filteredData, {
    layers: ["os_lobby"],
    leafNameKey: "os_station",
    leafValueKey: "os_total_occurence",
    leafTextKey: "os_station",
  });
  return (
    <div>
      {/* {a && (
        <SunburstChart
          data={a}
          length={a?.length}
          from={"lost trains"}
          chartHeight={"350px"}
        />
      )} */}
      <div className="row">
        <div className="col-md  ">
          <div className=" newUiBody m-1">
            <h5 className="bg-dark text-white p-1"> lobby wise occurrence </h5>
            <LineRaceChart
              data={chartDataLobbyWise}
              setSelectedLineBar={setSelectedLineBar}
              barName={"lobby"}
            />
          </div>
        </div>
        <div className="col-md ">
          <div className="newUiBody m-1">
            <div className="d-flex justify-content-between bg-dark text-white p-1">
              <h5 className=""> Month wise occurrence </h5>{" "}
              <OverlayTrigger
                placement={"top"}
                delay={{ show: 100, hide: 200 }}
                overlay={<Tooltip id={"lobby reset"}>Reset lobby </Tooltip>}
              >
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => setSelectedLobby("")}
                >
                  <RiResetLeftFill />
                </button>
              </OverlayTrigger>
            </div>
            <LineRaceChart
              data={chartDataMonthWise}
              setSelectedLineBar={setSelectedLineBar}
              barName={"month"}
            />
          </div>
        </div>
      </div>
      <div className="newUiBody">
        <div className="d-flex justify-content-between bg-dark text-white p-1">
          <h5 className=""> Tree Map for occurrence </h5>{" "}
          <OverlayTrigger
            placement={"top"}
            delay={{ show: 100, hide: 200 }}
            overlay={
              <Tooltip id={"lobby reset"}>Reset selected Month </Tooltip>
            }
          >
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => setSelectedMonth("")}
            >
              <RiResetLeftFill />
            </button>
          </OverlayTrigger>
        </div>
        <TreeMapChart2
          chartData={treeMapData}
          setTreeMapPath={setTreeMapPath}
          mPath={["_", "Lobby", "Station", "Month", "occurrence"]}
        />
      </div>
    </div>
  );
};
export default CrewOutsideGraph;
